import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';

// Imports dos componentes MUI
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box, CircularProgress
} from '@mui/material';

const ObservacaoModal = ({ open, onClose, hospede }) => {
  const [observacao, setObservacao] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    // Carrega a observação existente quando o modal abre
    if (hospede) {
      setObservacao(hospede.observacao || '');
    }
  }, [hospede, open]);

  const handleSave = async () => {
    if (!hospede || !hospede.id) {
      toast.error("ID do hóspede não encontrado.");
      return;
    }
    setSalvando(true);
    try {
      const hospedeRef = doc(db, 'hospedes', hospede.id);
      await updateDoc(hospedeRef, {
        observacao: observacao
      });
      toast.success("Observação salva com sucesso!");
      onClose(); // Fecha o modal após salvar
    } catch (error) {
      console.error("Erro ao salvar observação: ", error);
      toast.error("Não foi possível salvar a observação.");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Observações sobre {hospede?.nome}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mt: 1 }}>
          <TextField
            label="Digite sua observação..."
            fullWidth
            multiline
            rows={5}
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            placeholder="Ex: Hóspede VIP, alérgico a camarão, solicitou berço, etc."
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">Cancelar</Button>
        <Button onClick={handleSave} variant="contained" disabled={salvando}>
          {salvando ? <CircularProgress size={24} color="inherit" /> : 'Salvar Observação'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ObservacaoModal;